import { Product } from "gen/product/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useSearchProductsV2 } from "features/api/search"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export function useProductFilter({
  key = "product",
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    "persistInUrl" | "key" | "initialSelectedOptions"
  >
> = {}) {
  const { results, setQuery, loadNext } = useSearchProductsV2()

  const products = useMemo(() => {
    const products: Product[] = []
    for (const { product } of results) {
      if (!product) continue
      products.push(product)
    }
    return products
  }, [results])

  const { filter, selected: selectedProductIds } = useIdFilter({
    key,
    label: "Product",
    values: products,
    labelExtractor: (product) => product.name,
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    onLoadMore: loadNext,
    useFilter: (props) => {
      return useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      })
    },
  })

  return { filter, selectedProductIds }
}
